module.exports = __webpack_public_path__ + "static/media/rings.b47a4ee2.svg";